import { useCallback, useEffect, useMemo, useState } from 'react';

import ProductSdkApi from '@Modules/integration/productSdk/ProductSdkApi';
import { submitSdkSetupHandoff } from '@Utils/sdkSetupHandoff';
import { buildSdkSetupHandoffPayload } from '@Utils/sdkSetupHandoffPayload';

export default function useSdkSetupHandoff({
  productId,
  currentUser,
  enabled = true,
}) {
  const [loading, setLoading] = useState(false);
  const [sdkReady, setSdkReady] = useState(false);
  const [android, setAndroid] = useState(null);
  const [web, setWeb] = useState(null);
  const [ios, setIos] = useState(null);

  useEffect(() => {
    if (!productId || !enabled) {
      setSdkReady(false);
      setAndroid(null);
      setWeb(null);
      setIos(null);
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setSdkReady(false);

    Promise.all([
      ProductSdkApi.viewAndroid(),
      ProductSdkApi.viewWeb(),
      ProductSdkApi.viewIOS(),
    ])
      .then(([a, w, i]) => {
        if (cancelled) {
          return;
        }
        setAndroid(a);
        setWeb(w);
        setIos(i);
        setSdkReady(true);
      })
      .catch(() => {
        if (!cancelled) {
          setSdkReady(false);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [productId, enabled]);

  const payload = useMemo(
    () =>
      buildSdkSetupHandoffPayload({
        productId,
        currentUser,
        android,
        web,
        ios,
      }),
    [productId, currentUser, android, web, ios]
  );

  const onSetupNow = useCallback(() => {
    if (!sdkReady) {
      return;
    }
    submitSdkSetupHandoff(payload);
  }, [payload, sdkReady]);

  return {
    loading,
    sdkReady,
    onSetupNow,
  };
}
